<template>
    <div>
        <div class="topText">会员中心</div>
        <div class="header">
            <div v-if="userInfo.isLogin">
                <img class="user-avatarUrl" :src="userInfo.head_pic" />
                <div class="user-info">
                    <div class="user-name">
                       <p> {{userInfo.nickname}}</p>
                       <p>{{userInfo.article_num}}</p>
                    </div>
                    <div
                        class="detail-info"
                        wx:if="userInfo.college_province"
                    >{{userInfo.college_province}}{{userInfo.college_year}}</div>
                </div>
            </div>
            <div v-else>
                <div class="login">
                    <img
                        src="https://new.schoolpi.net/attach/small_program/center/head_pic.png"
                        alt
                    />
                    <p @click="goLogin">用户登录</p> <span class="goOut"> / </span>
                    <span @click="goRegister">注册</span>
                </div>
            </div>
        </div>
        <!-- v-if="userInfo.isLogin" -->
        <div>
            <div class="list" @click="goCollection" data-type="1">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/collect.png"
                />
                <div class="list-name">我的收藏</div>
                <van-icon name="arrow" size="20" />
            </div>
            <!-- <div class="list" @click="goBindPhone" data-type="2">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/phone.png"
                />
                <div class="list-name">绑定手机</div>
                <van-icon name="arrow" size="20" />
            </div>-->

            <div class="list" @click="goZhiyuan" data-type="3">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/list.png"
                />
                <div class="list-name">我的志愿单</div>
                <van-icon name="arrow" size="20" />
            </div>
            <a class="list" href="tel:0551-66102699">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/contact.png"
                />
                <div class="list-name">联系客服</div>
                <van-icon name="arrow" size="20" />
            </a>
            <div class="list" @click="goAbout">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/about.png"
                />
                <div class="list-name">关于校派</div>
                <van-icon name="arrow" size="20" />
            </div>

            <div class="list" @click="agreement(4)">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/user.png"
                />
                <div class="list-name">用户协议</div>
                <van-icon name="arrow" size="20" />
            </div>
            <div class="list" @click="agreement(5)">
                <img
                    class="icon"
                    src="https://new.schoolpi.net/attach/small_program/center/serve.png"
                />
                <div class="list-name">服务协议</div>
                <van-icon name="arrow" size="20" />
            </div>
        </div>

        <!-- <div>{{shouji}}</div> -->
    </div>
</template>

<script scoped>
export default {
    data() {
        return {
            shouji: this.$store.state.userInfo.shouji,
            userInfo: {}
        };
    },
    created() {
        console.log(this.$store.state.userInfo);
        this.userInfo = this.$store.state.userInfo;
    },
    methods: {
        // 去服务协议
        agreement(e) {
            this.$router.push({
                path: "/serve",
                query: {
                    key: e
                }
            });
        },
        // 去注册
        goRegister() {
            this.$router.push("/register");
        },
        // 去登录
        goLogin() {
            this.$router.push("/login");
        },
        // 去我的收藏页
        goCollection() {
            this.$router.push("/collection");
        },
        // 去关于校派页
        goAbout() {
            this.$router.push("/about");
        },
        // // 去绑定手机页
        // goBindPhone() {
        //     this.$router.push("/bindPhone");
        // },
        // 去志愿单页
        goZhiyuan() {
            this.$router.push("/zhiyuandan");
        }
    }
};
</script>

<style scoped>
.goOut{
    margin: 0 20px;
}
.login {
    width: 240px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
}
.login img {
    width: 3.125rem;
    height: 3.125rem;
    border-radius: 0.9375rem;
    margin-right: 20px;
}
.header {
    display: flex;
    padding: 14px 30px;
}

.default-pic,
.user-avatarUrl {
    width: 3.125rem;
    height: 3.125rem;
    border-radius: 0.9375rem;
    float: left;
    margin-right: 20px;
    margin-top: 8px;
}
.user-info {
    float: left;
    font-size: 20px;
    font-weight: bold;
}
.topText {
    background: #20d9d9;
    font-size: 1rem;
    color: #fff;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.list {
    display: flex;
    margin: 0.9375rem 1.75rem;
    position: relative;
}

.icon {
    width: 1.5625rem;
    height: 1.5625rem;
    margin-top: 0.3125rem;
}

.list-name {
    font-size: 1rem;
    line-height: 2.1875rem;
    letter-spacing: -1px;
    color: #5b5b5b;
    margin-left: 1.5625rem;
}

.arrow-position {
    position: absolute;
    right: 0;
    top: 0.4375rem;
    line-height: 2.1875rem;
}

.van-icon {
    position: absolute;
    right: 0;
    line-height: 30px;
    color: #5b5b5b;
}
</style>
